var _rect, _path, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3727_54376)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#9464DF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3727_54376",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V40H40V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3727_54376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2128 9H15.7872C14.7915 9 14 9.81013 14 10.7722V29.2278C14 30.2152 14.817 31 15.7872 31H24.2128C25.2085 31 26 30.1899 26 29.2278V10.7975C26 9.81013 25.2085 9 24.2128 9ZM18.034 10.4177H21.9915C22.1702 10.4177 22.2979 10.5443 22.2979 10.7215C22.2979 10.8987 22.1702 11.0253 21.9915 11.0253H18.034C17.8553 11.0253 17.7277 10.8987 17.7277 10.7215C17.7277 10.5443 17.8553 10.4177 18.034 10.4177ZM20 30.2658C19.4128 30.2658 18.9277 29.7848 18.9277 29.2025C18.9277 28.6203 19.4128 28.1392 20 28.1392C20.5872 28.1392 21.0723 28.6203 21.0723 29.2025C21.0723 29.7848 20.5872 30.2658 20 30.2658ZM25.1319 27.3797H14.8426V12.2658H25.1319V27.3797Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 13,
    width: 10,
    height: 14,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3727_54376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/Mobile.154bfe957f4b180708a4dd7bc3baa817.svg";
export { ForwardRef as ReactComponent };